module.exports = __webpack_public_path__ + "static/index/img/baikal-402.e0e0845d.jpg";